<template>
  <el-dialog
    :title="title"
    :before-close="handleClose"
    :visible.sync="isOpen"
    :show-close="true"
    :close-on-click-modal="false"
    width="800px"
    top="5vh"
    custom-class="modern-dialog"
    @open="handleOpen"
  >
    <div class="dialog-header-themed">
      <div class="themed-icon">
        <i :class="showDetail ? 'el-icon-monitor' : 'el-icon-edit'"></i>
      </div>
      <div class="themed-text">
        <h3>{{ title }}</h3>
        <p v-if="showDetail">Xem chi tiết thông số kết nối và trạng thái của thiết bị nhận diện AI.</p>
        <p v-else>Cập nhật cấu hình mạng, tài khoản modem, hoặc ghi chú của thiết bị nhận diện AI.</p>
      </div>
    </div>

    <el-form
      label-position="top"
      :model="devicesData"
      :rules="rules"
      ref="recognitionData"
      class="modern-dialog-form"
    >
      <!-- Section 1: Basic Information -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-info"></i> Thông tin cơ bản</h4>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tên thiết bị (Đầu ghi)" prop="nameDevice">
              <el-input :disabled="showDetail" v-model="devicesData.nameDevice" placeholder="Nhập tên đầu ghi" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Version điểm danh">
              <el-select :disabled="showDetail" v-model="devicesData.versionAttendance" class="w-full">
                <el-option
                  v-for="(item, index) in listVersionAttendance"
                  :key="index"
                  :value="item.value"
                  :label="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Loại đầu ghi / Hãng" prop="typeDevice">
              <el-radio-group v-model="devicesData.typeDevice" :disabled="showDetail" class="modern-radio-group">
                <el-radio-button label="Hik">Hikvision</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Số Serial Number thiết bị (Device SN)" prop="deviceSN">
              <el-input :disabled="showDetail" v-model="devicesData.deviceSN" placeholder="Nhập số Serial thiết bị" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- Section 2: Network Configuration -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-share"></i> Cấu hình mạng</h4>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tên miền (Domain)" prop="schoolDomain">
              <el-input :disabled="showDetail" v-model.trim="devicesData.schoolDomain" placeholder="Nhập tên miền" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Địa chỉ IP Local" prop="ipLocal">
              <el-input :disabled="showDetail" v-model.trim="devicesData.ipLocal" placeholder="Nhập IP local" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="Cổng Port Local" prop="port">
              <el-input-number :disabled="showDetail" v-model="devicesData.port" :controls="false" placeholder="Port Local" class="w-full" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Port DVR" prop="portDVR">
              <el-input-number :disabled="showDetail" v-model="devicesData.portDVR" :controls="false" placeholder="Port DVR" class="w-full" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Port RTSP" prop="portRTSP">
              <el-input-number :disabled="showDetail" v-model="devicesData.portRTSP" :controls="false" placeholder="Port RTSP" class="w-full" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- Section 3: Authentication Accounts -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-key"></i> Tài khoản thiết bị & Modem</h4>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tài khoản admin đầu ghi" prop="adminAcc">
              <el-input :disabled="showDetail" v-model.trim="devicesData.adminAcc" placeholder="Nhập tài khoản đầu ghi" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mật khẩu admin đầu ghi" prop="adminPassword">
              <el-input :disabled="showDetail" v-model.trim="devicesData.adminPassword" type="password" show-password placeholder="Nhập mật khẩu" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tài khoản Modem" prop="modemAcc">
              <el-input :disabled="showDetail" v-model.trim="devicesData.modemAcc" placeholder="Nhập tài khoản Modem" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mật khẩu Modem" prop="modemPassword">
              <el-input :disabled="showDetail" v-model.trim="devicesData.modemPassword" type="password" show-password placeholder="Nhập mật khẩu Modem" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- Section 4: Webhook & MAC Connection Status -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-connection"></i> Trạng thái kết nối & Webhook</h4>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Địa chỉ MAC thiết bị" prop="macAddress">
              <el-input
                :disabled="showDetail"
                v-model.trim="devicesData.macAddress"
                readonly
                placeholder="Nhấp truy xuất để lấy địa chỉ Mac..."
              >
                <template #append v-if="!showDetail">
                  <el-button type="primary" @click="handleFetchMac" class="fetch-mac-btn">
                    <i class="el-icon-refresh"></i> Truy xuất MAC
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="mt-2">
          <!-- Webhook card -->
          <el-col :span="12">
            <div class="status-control-card">
              <span class="control-label">Đăng ký Webhook</span>
              <div class="control-body">
                <el-tag :type="devicesData.webhookRegister ? 'success' : 'danger'" size="medium" effect="light">
                  {{ devicesData.webhookRegister ? 'Đã đăng ký Webhook' : 'Chưa đăng ký' }}
                </el-tag>
                <div v-if="!showDetail" class="control-actions">
                  <el-button 
                    v-if="!devicesData.webhookRegister" 
                    type="success" 
                    size="small" 
                    icon="el-icon-plus" 
                    :loading="loading.registerWebhook" 
                    @click="handleClickRegisterWebhook"
                  >Đăng ký</el-button>
                  <el-button 
                    v-else 
                    type="danger" 
                    size="small" 
                    icon="el-icon-delete" 
                    :loading="loading.deleteWebhook" 
                    @click="handleClickDeleteWebhook"
                  >Hủy đăng ký</el-button>
                </div>
              </div>
            </div>
          </el-col>
          
          <!-- Ping status card -->
          <el-col :span="12">
            <div class="status-control-card">
              <span class="control-label">Trạng thái Hoạt động (Ping)</span>
              <div class="control-body">
                <span class="status-badge" :class="devicesData.active ? 'online' : 'offline'">
                  <span class="dot"></span>
                  {{ devicesData.active ? 'Online' : 'Offline' }}
                </span>
                <div v-if="!showDetail" class="control-actions">
                  <el-button 
                    type="primary" 
                    size="small" 
                    icon="el-icon-refresh" 
                    :loading="loading.checkConnectionDevice" 
                    @click="handleClickCheckConnectionDevice"
                  >Kiểm tra kết nối</el-button>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- Section 5: Notes -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-notebook-2"></i> Ghi chú</h4>
        <el-form-item label="" prop="note">
          <el-input :disabled="showDetail" type="textarea" v-model="devicesData.note" :rows="3" placeholder="Nhập ghi chú thiết bị..." />
        </el-form-item>
      </div>
    </el-form>

    <template #footer>
      <div class="dialog-footer-themed">
        <el-button type="danger" plain size="medium" icon="el-icon-circle-close" @click="handleClose">
          Đóng
        </el-button>
        <el-button v-if="!showDetail" type="success" size="medium" icon="el-icon-circle-check" :loading="loading.submit" @click="submitForm">
          Lưu lại
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import DeviceRecognitionService from "@/services/ManagerRecognition/DeviceRecognitionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    },
    showDetail: {
      type: Boolean,
      default: () => false
    },
    idDevice: {
      type: Number,
      default: () => 0
    }
  },

  data() {
    return {
      devicesData: {},
      title: "",
      rules: {
        nameDevice: [
          { required: true, message: "Tên đầu ghi không được để trống", trigger: "blur" }
        ],
        typeDevice: [
          { required: true, message: "Loại đầu ghi không được để trống", trigger: "change" }
        ],
        adminAcc: [
          { required: true, message: "Tài khoản đầu ghi không được để trống", trigger: "blur" }
        ],
        adminPassword: [
          { required: true, message: "Mật khẩu không được để trống", trigger: "blur" }
        ],
        portDVR: [
          { required: true, message: "Port DVR không được để trống", trigger: "blur" }
        ],
        schoolDomain: [
          { required: true, message: "Tên miền không được để trống", trigger: "blur" }
        ],
        port: [
          { required: true, message: "Port Local không được để trống", trigger: "blur" }
        ],
        ipLocal: [
          { required: true, message: "IP local không được để trống", trigger: "blur" }
        ]
      },
      listVersionAttendance: [
        { id: 1, value: "VERSION_1" },
        { id: 2, value: "VERSION_2" },
        { id: 3, value: "VERSION_3" },
        { id: 4, value: "VERSION_4" }
      ],
      loading: {
        submit: false,
        checkConnectionDevice: false,
        registerWebhook: false,
        deleteWebhook: false
      }
    };
  },

  methods: {
    handleClose() {
      this.$refs["recognitionData"].resetFields();
      this.$emit("closeDialog");
    },
    
    handleOpen() {
      this.title = this.showDetail ? "Chi tiết thiết bị AI" : "Cập nhật thiết bị AI";
      DeviceRecognitionService.getDetailOneDevices(this.idDevice)
        .then((response) => {
          this.devicesData = response.data.data || {};
        })
        .catch((error) => {
          console.error(error);
        });
    },

    handleFetchMac() {
      DeviceRecognitionService.checkDevicesMacAddress(this.idDevice)
        .then((response) => {
          if (response.data.status === 200) {
            const mac = response.data.data.macAddress;
            this.devicesData.macAddress = mac ? mac.toLowerCase() : "";
            if (this.devicesData.macAddress) {
              NotifyMessage.leftCornerNotificationSuccess("Lấy địa chỉ MAC thành công!");
            } else {
              NotifyMessage.leftCornerNotificationError("Không tìm thấy địa chỉ MAC!");
            }
          }
        })
        .catch((error) => {
          console.error(error);
          NotifyMessage.leftCornerNotificationError("Truy xuất địa chỉ MAC thất bại!");
        });
    },

    async handleClickRegisterWebhook() {
      this.loading.registerWebhook = true;
      try {
        await this.createConfigSchool();
        const response = await DeviceRecognitionService.registerWebhook(this.idDevice);
        if (response.data.status === 200) {
          this.devicesData.webhookRegister = response.data.data.webhookRegister;
          if (response.data.data.webhookRegister) {
            NotifyMessage.leftCornerNotificationSuccess("Đăng ký Webhook thành công!");
          } else {
            NotifyMessage.leftCornerNotificationError("Đăng ký Webhook thất bại!");
          }
        }
      } catch (error) {
        console.error(error);
        NotifyMessage.leftCornerNotificationError("Đăng ký Webhook lỗi!");
      } finally {
        this.loading.registerWebhook = false;
      }
    },

    handleClickDeleteWebhook() {
      this.loading.deleteWebhook = true;
      DeviceRecognitionService.deleteWebhook(this.idDevice)
        .then((response) => {
          if (response.data.status === 200) {
            this.devicesData.webhookRegister = response.data.data.webhookRegister;
            if (!response.data.data.webhookRegister) {
              NotifyMessage.leftCornerNotificationSuccess("Hủy đăng ký Webhook thành công!");
            } else {
              NotifyMessage.leftCornerNotificationError("Hủy đăng ký Webhook thất bại!");
            }
          }
        })
        .catch((error) => {
          console.error(error);
          NotifyMessage.leftCornerNotificationError("Hủy đăng ký Webhook lỗi!");
        })
        .finally(() => {
          this.loading.deleteWebhook = false;
        });
    },

    async submitForm() {
      this.$refs["recognitionData"].validate(async (valid) => {
        if (valid) {
          this.loading.submit = true;
          let data = {
            id: this.idDevice,
            nameDevice: this.devicesData.nameDevice,
            typeDevice: this.devicesData.typeDevice,
            adminAcc: this.devicesData.adminAcc,
            adminPassword: this.devicesData.adminPassword,
            schoolDomain: this.devicesData.schoolDomain,
            port: this.devicesData.port,
            portRTSP: this.devicesData.portRTSP,
            portDVR: this.devicesData.portDVR,
            deviceSN: this.devicesData.deviceSN,
            macAddress: this.devicesData.macAddress,
            ipLocal: this.devicesData.ipLocal,
            modemAcc: this.devicesData.modemAcc,
            modemPassword: this.devicesData.modemPassword,
            active: this.devicesData.active,
            note: this.devicesData.note,
            webhookRegister: this.devicesData.webhookRegister,
            idSchool: parseInt(this.devicesData.idSchool),
            versionAttendance: this.devicesData.versionAttendance
          };
          
          await DeviceRecognitionService.updateDeviceRecognition(data)
            .then((response) => {
              if (response.status === 200) {
                NotifyMessage.leftCornerNotificationSuccess("Cập nhật thiết bị thành công!");
                this.handleClose();
              } else {
                NotifyMessage.leftCornerNotificationError("Cập nhật thiết bị thất bại!");
              }
            })
            .catch((error) => {
              console.error(error);
              NotifyMessage.leftCornerNotificationError("Cập nhật thiết bị thất bại!");
            })
            .finally(() => {
              this.loading.submit = false;
            });
        }
      });
    },

    async createConfigSchool() {
      await DeviceRecognitionService.createConfigDevice(this.devicesData.idSchool).then((response) => {
        console.log(response);
      });
    },

    handleClickCheckConnectionDevice() {
      this.loading.checkConnectionDevice = true;
      let idList = [this.idDevice];
      DeviceRecognitionService.checkConnectionDevice(idList)
        .then((response) => {
          if (response.data.status === 200) {
            this.devicesData.active = response.data.data[0].active;
            NotifyMessage.leftCornerNotificationSuccess("Kiểm tra kết nối thành công!");
          }
        })
        .catch((error) => {
          console.error(error);
          NotifyMessage.leftCornerNotificationError("Kiểm tra kết nối thất bại!");
        })
        .finally(() => {
          this.loading.checkConnectionDevice = false;
        });
    }
  }
};
</script>

<style lang="scss">
/* Modern styling for Dialog headers and layout */
.modern-dialog {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;

  .el-dialog__header {
    display: none; /* Custom header used instead */
  }

  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
.dialog-header-themed {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 28px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #fff;

  .themed-icon {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.25);
    font-size: 20px;
  }

  .themed-text {
    h3 {
      margin: 0 0 4px 0;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
    p {
      margin: 0;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.modern-dialog-form {
  padding: 24px 28px;
  max-height: 60vh;
  overflow-y: auto;
}

.form-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;

  .section-divider {
    margin: 0 0 16px 0;
    font-size: 13px;
    font-weight: 700;
    color: #3b82f6;
    display: flex;
    align-items: center;
    gap: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 8px;
  }
}

/deep/ .el-form-item {
  margin-bottom: 16px;

  .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding: 0 0 4px 0 !important;
    font-size: 13px;
  }
  
  .el-input__inner {
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    &:focus {
      border-color: #3b82f6;
    }
  }
  
  /* High contrast readable disabled fields for detail view */
  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner {
    background-color: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
    font-weight: 600;
    cursor: default;
  }
}

.modern-radio-group {
  /deep/ .el-radio-button__inner {
    border-radius: 6px !important;
    padding: 10px 20px;
    font-weight: 600;
  }
}

.fetch-mac-btn {
  background-color: #3b82f6 !important;
  color: white !important;
  font-weight: 600;
  border-radius: 0 6px 6px 0 !important;
  margin: -10px -20px !important;
  border: none;
  &:hover {
    background-color: #2563eb !important;
  }
}

/* Status Control Card styling (Webhook & Ping state) */
.status-control-card {
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);

  .control-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .control-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 36px;
  }
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 9999px;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  &.online {
    background-color: #f0fdf4;
    color: #166534;
    .dot {
      background-color: #22c55e;
      box-shadow: 0 0 8px #22c55e;
      animation: pulseGreen 2s infinite;
    }
  }

  &.offline {
    background-color: #fef2f2;
    color: #991b1b;
    .dot {
      background-color: #ef4444;
    }
  }
}

@keyframes pulseGreen {
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7); }
  70% { transform: scale(1); box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}

.dialog-footer-themed {
  padding: 16px 28px;
  background: #f1f5f9;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

.w-full {
  width: 100%;
}

.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.gap-2 {
  gap: 8px;
}
.gap-1 {
  gap: 4px;
}
.mt-2 {
  margin-top: 8px;
}
</style>